export default [
  {
    Val: 1,
    Name: 'COM_MSG032',
  },
  {
    Val: 3,
    Name: 'COM_MSG033',
  },
  {
    Val: 5,
    Name: 'COM_MSG033',
  },
  {
    Val: 7,
    Name: 'COM_MSG033',
  },
  {
    Val: 14,
    Name: 'COM_MSG033',
  },
  {
    Val: -1,
    Name: 'COM_MSG034',
  }
]